import NotificationItem from '@components/NotificationPreview/ui/NotificationItem';
import EmptyData from '@components/EmptyData/ui/EmptyData';
import useNotification from '@hooks/useNotification';
import Box from '@mui/material/Box';

function NotificationList() {
  const { notifications } = useNotification();

  return (
    <Box
      sx={{
        height: 'calc(100vh - 100px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        width: '100%',
      }}
    >
      <Box display="flex" flexDirection="column" gap={3} flexGrow={1}>
        {notifications.length === 0 ? (
          <EmptyData
            title="No Notifications Yet"
            description="Stay tuned! Notifications about your activity will show up here."
          />
        ) : (
          notifications.map((item) => (
            <NotificationItem key={item.id} notification={item} />
          ))
        )}
      </Box>
    </Box>
  );
}

export default NotificationList;
